import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Feedback } from '../feedback';
import { useSelector, useDispatch } from 'react-redux'


const ECChatReply = () => {
    // const dispatch = useDispatch();
    // const chatReplyBn = useSelector((state) => state.asr.chatReply);
    // const chatReplyEn = useSelector((state) => state.asr.chatReplyEn);

    const chatId = useSelector((state) => state.ecChat.id);
    const chatResponse = useSelector((state) => state.ecChat.response);
    const chatResponseTag = useSelector((state) => state.ecChat.responseTag);
    const chatTimeTaken = useSelector((state) => state.ecChat.timeTaken);
    const chatAsrTime = useSelector((state) => state.ecChat.asrTime);
    const chatChatTime = useSelector((state) => state.ecChat.chatTime);
    const chatProbability = useSelector((state) => state.ecChat.probability);
    const chatUserInput = useSelector((state) => state.ecChat.userInput);
    const chatIsRelevant = useSelector((state) => state.ecChat.isRelevant);
    const chatDialPad = useSelector((state) => state.ecChat.dialPad);
    const chatReply = chatResponse === "" ? "" :
        "Response: " + chatResponse + 
        "\nID: " + chatId + 
        "\nChat Response Tag: " + chatResponseTag + 
        "\nTime Taken: " + chatTimeTaken + 
        "ms\nASR Time: " + chatAsrTime +
        "ms\nChat Time: " + chatChatTime +
        "ms\nCommunication Time: " + (chatTimeTaken - (chatAsrTime + chatChatTime)) +
        "ms\nProbability: " + chatProbability;

    return (
        <div className='chat-reply mini-card'>
            <h4>Chat</h4>
            <div>
                <textarea
                    value={ chatReply }
                    rows="7" style={{"width": "100%"}}
                    readOnly />
            </div>           
            <div>
                <Feedback
                    type = {"chat"} />
            </div>
        </div>
    );
}

export default ECChatReply;
